import { Component, inject } from '@angular/core';
import { HOME_ROUTE_TARGETS } from 'src/app/@pages/home/@shared/home-route-targets';
import { NavController } from '@ionic/angular';
import { isPublicWebAppBuild } from 'src/app/@shared/is-public-web-app';

@Component({
  host: {
    class: 'split-pane-main-header',
  },
  selector: 'split-pane-main-header',
  template: `
    @if (!isPublicWebApp) {
      <ion-header class="split-pane-main-header__inner" mode="ios">
      <ion-toolbar class="split-pane-main-header-toolbar">
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
          <a [href]="homeRoute" class="split-pane-header-logo" (click)="onHomeLogoClicked($event)">
            <img src="./assets/images/logo.png"/>
          </a>
        </ion-title>
        <ng-content select="[slot=end]"></ng-content>
      </ion-toolbar>
      </ion-header>
    }
  `,
})
export class SplitPaneMainHeaderComponent {
  public readonly isPublicWebApp = isPublicWebAppBuild();

  public homeRoute: string = HOME_ROUTE_TARGETS.loggedOutHome;

  private navController = inject(NavController);

  public ngOnInit(): void {
    // do something
  }

  public onHomeLogoClicked(event: Event): void {
    event.preventDefault();

    this.navController.navigateRoot(this.homeRoute).catch();
  }
}
